import { DueDiligenceStatus } from '@gcv/shared';

import { MyProvidersStatus } from 'domain/enums';

export const convertDueDiligenceStatus = (status: DueDiligenceStatus): MyProvidersStatus => {
  switch (status) {
    case DueDiligenceStatus.BANK_IN_PROGRESS:
    case DueDiligenceStatus.BANK_PENDING:
    case DueDiligenceStatus.GCV_IN_PROGRESS:
      return MyProvidersStatus.Started;
    case DueDiligenceStatus.BANK_AWAITING_REVIEW:
      return MyProvidersStatus.Submitted;
    case DueDiligenceStatus.BANK_REVIEW_IN_PROGRESS:
    case DueDiligenceStatus.UPDATE_REQUIRED:
      return MyProvidersStatus.UnderReview;
    case DueDiligenceStatus.BANK_APPROVED:
    case DueDiligenceStatus.GCV_APPROVED:
      return MyProvidersStatus.Active;
    case DueDiligenceStatus.BANK_DISCONNECTED:
      return MyProvidersStatus.Inactive;
    case DueDiligenceStatus.GCV_AWAITING_REVIEW:
    case DueDiligenceStatus.GCV_PENDING:
    default:
      return MyProvidersStatus.NotStarted;
  }
};
